import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, lastValueFrom, Observable } from 'rxjs';
import { ArticleFeatureDto } from 'src/app/shared/dto/article-feature.dto';
import { ArticleFeatureResponseDto } from 'src/app/shared/dto/pagination/article-feature-response.dto';
import { BaseService } from 'src/app/shared/services/base.service';
import { SocketService } from 'src/app/shared/services/socket.service';
import { Messages } from 'src/app/shared/sockets/enums/messages';
import { Client, formatClientRoom, RoomNames } from 'src/app/shared/sockets/enums/rooms';

@Injectable({
    providedIn: 'root',
})
export class ArticleFeaturesService extends BaseService {
    
    public articleFeatures$: Observable<ArticleFeatureDto[]>;
    private articleFeaturesSubject = new BehaviorSubject<ArticleFeatureDto[]>([]);

    private readonly socketService = inject(SocketService);
    constructor(httpClient: HttpClient) {
        super(httpClient, 'article-features');
        this.articleFeatures$ = this.articleFeaturesSubject.asObservable();
    }

    async setupWebSocket(): Promise<void> {
        try {
            this.articleFeaturesSubject.next((await this.findAll()).articleFeatures);
            this.socketService.conectSocketRoom(formatClientRoom(Client.DEFAULT_CLIENT, RoomNames.ARTICLE_FEATURES_ROOM));
            this.socketService.getNotifications(Messages.ARTICLE_FEATURES_CHANGED).subscribe(async () => {
                const response = await this.findAll();
                this.articleFeaturesSubject.next(response.articleFeatures);
            });
        } catch (e: any) {
            throw new Error(`Error al establecer conexión con el socket de Tipos de Artículo. Error: ${e.message}`);
        }
    }

    disconnectWebSocket(): void {
        this.socketService.disconnectSocketRoom(formatClientRoom(Client.DEFAULT_CLIENT, RoomNames.ARTICLE_FEATURES_ROOM));
    }

    async findAll(): Promise<ArticleFeatureResponseDto> {
        try {
            const request = this.httpClient.get<ArticleFeatureResponseDto>(`${this.url}/findAll`);

            return (await lastValueFrom(request));
        } catch (e: any) {
            throw new Error(`No se ha encontrado ninguna característica de artículo. Error: ${e.message}`);
        }
    }
}
